import { AppIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import type { AppDispatch } from '@backrs_ui/grow-ui/src/redux/store';
import { openAwardLetterTab } from '@backrs_ui/grow-ui/src/redux/tabs/tabs.slice';
import type { UserCollege } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { IconButton } from '@mui/material';

import { canOpenAwardLetter } from '../myColleges.util';

const STRINGS = appStrings.modules.myColleges;

export const awardLetterAction = (college: UserCollege, dispatch: AppDispatch) => ({
  icon: college.has_award_letter ? ('FileCheck02' as const) : ('FilePlus02' as const),
  onClick: () => {
    dispatch(openAwardLetterTab({ userCollegeId: college.id, name: college.name }));
  },
  disabled: !canOpenAwardLetter(college),
  tooltipHoverText: college.has_award_letter ? STRINGS.viewAwardLetter : STRINGS.addAwardLetter,
});

export const AwardLetterButton = ({
  id,
  college,
}: Readonly<{ id: string; college: UserCollege }>) => {
  const action = awardLetterAction(college, useAppDispatch());

  return (
    <IconButton
      id={id}
      onClick={action.onClick}
      aria-label={STRINGS.awardLetterAriaLabel(college.name, college.has_award_letter)}
      disabled={action.disabled}
      size="small"
    >
      <AppIcon
        iconName={action.icon}
        diameter="16px"
        color={
          action.disabled ? 'Colors/Foreground/fg-disabled-subtle' : 'Colors/Text/text-tertiary'
        }
      />
    </IconButton>
  );
};
